import type { SVGProps } from "react";
const SenecPictogramMemory = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 6.5C12.4477 6.5 12 6.94772 12 7.5V33.5C12 34.0523 11.5523 34.5 11 34.5C10.4477 34.5 10 34.0523 10 33.5V7.5C10 5.84315 11.3431 4.5 13 4.5H35C36.6569 4.5 38 5.84315 38 7.5V39.5C38 41.1569 36.6569 42.5 35 42.5H13C11.3431 42.5 10 41.1569 10 39.5V37.5C10 36.9477 10.4477 36.5 11 36.5C11.5523 36.5 12 36.9477 12 37.5V39.5C12 40.0523 12.4477 40.5 13 40.5H35C35.5523 40.5 36 40.0523 36 39.5V7.5C36 6.94772 35.5523 6.5 35 6.5H13ZM32 12.5L16 12.5C15.4477 12.5 15 12.0523 15 11.5C15 10.9477 15.4477 10.5 16 10.5L32 10.5C32.5523 10.5 33 10.9477 33 11.5C33 12.0523 32.5523 12.5 32 12.5ZM15 30.5H23V32.5H15V30.5ZM25 30.5H33V32.5H25V30.5ZM15 34.5H23V36.5H15V34.5ZM25 34.5H33V36.5H25V34.5Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramMemory;
